import { type FC, type SVGProps, useMemo } from "react";
import clsx from "clsx";

/** SVGアイコンコンポーネント共通の Props */
export interface IconProps extends SVGProps<SVGSVGElement> {
  /** Tailwind のサイズ・色クラス（例: "w-5 h-5 text-brand-500"） */
  className?: string;
}

/** SVGアイコンを HeroIcon 互換の React コンポーネントとしてラップするヘルパー */
export function createIcon(
  displayName: string,
  renderPath: (props: SVGProps<SVGPathElement>) => React.ReactNode,
): FC<IconProps> {
  const IconComponent: FC<IconProps> = ({
    className,
    ...rest
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      aria-hidden="true"
      className={clsx("shrink-0", className)}
      {...rest}
    >
      {renderPath({})}
    </svg>
  );

  IconComponent.displayName = displayName;
  return IconComponent;
}

/** raw SVG文字列（?raw import）からReactコンポーネントを生成するヘルパー */
export function createSvgIcon(rawSvg: string): FC<IconProps> {
  const processed = rawSvg
    .replace(/stroke="black"/g, 'stroke="currentColor"')
    .replace(/fill="black"/g, 'fill="currentColor"');

  const Component: FC<IconProps> = ({ className }) => {
    const html = useMemo(() => {
      return processed.replace(
        /^<svg /,
        `<svg class="shrink-0 ${className ?? ''}" aria-hidden="true" `,
      );
    }, [className]);

    return <span dangerouslySetInnerHTML={{ __html: html }} style={{ display: 'inline-flex', pointerEvents: 'none' }} />;
  };
  return Component;
}
